import React from "react";
import { Box } from "@mui/material";

import { useCustomerProvider } from "../../../../context";

interface IProps {
  popup: string;
  setPopup: (popup: string) => void;
  extendFinamark: () => void;
}

const ExtendFinamarkUserConfirmWindow: React.FC<IProps> = ({ popup, setPopup, extendFinamark }) => {
  const { fina, setFina } = useCustomerProvider();

  return (
    <Box
      zIndex={10}
      position="fixed"
      className="fina fina-extend"
      style={{ display: popup === "fina-extend" ? "flex" : "none" }}
    >
      <div className="title">Extend Finamark User</div>
      <div style={{ display: "block" }}>
        Add{" "}
        <input
          type="text"
          name="days"
          placeholder="Days"
          value={fina.days}
          style={{ display: "inline", maxWidth: 50 }}
          onChange={(e) => setFina({ ...fina, days: e.target.value })}
        />{" "}
        days to Finamark subscription
      </div>

      <button type="button" onClick={() => extendFinamark()}>
        Extend
      </button>
      <button type="button" onClick={() => setPopup("")}>
        Cancel
      </button>
    </Box>
  );
};

export default ExtendFinamarkUserConfirmWindow;
